import type { FieldError } from 'react-hook-form';

/**
 * Erreur affichable sous un champ : une `FieldError` de react-hook-form, un message, ou rien.
 *
 * Les champs acceptent les trois formes parce que les écrans leur passent tantôt
 * `errors.champ`, tantôt un message calculé, tantôt `touched && message`.
 */
export type FieldErrorLike = FieldError | string | false | null | undefined;

/** Message d'une `FieldErrorLike`, ou chaîne vide. */
export const errorMessage = (error: FieldErrorLike): string =>
    typeof error === 'string' ? error : error ? (error.message ?? '') : '';
